import './all.css';

import { Container, Row, Col, Form, Button, ProgressBar  } from "react-bootstrap"
import {useState, useRef} from 'react';
import axios from "axios"


function Home() {
  const [progress, setProgress] = useState();
  const [selectedFile, setSelectedFile] = useState()
  //const [url, setURL] = useState('')
  const [file, setFile] = useState()
  //const [name, setName] = useState('')
  const [dragging, setDragging] = useState(false)
  const fileInput = useRef(null)

  const axiosInstance = axios.create({
    baseURL: "/api",
  })

  const copyToClipboard = (text) => {
    var textField = document.createElement('textarea')
    textField.innerText = text;
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
  }

  const handleClick = () => {
    fileInput.current.click()
  }

  const handleFileChange = e => {
    //console.log(e.target.files[0]);
    setSelectedFile(e.target.files[0])
}

  const submitHandler = e => {
    e.preventDefault()
    let formData = new FormData()
  
    formData.append("file", selectedFile)
    axiosInstance.post("/file", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: data => {
        //Set the progress value to show the progress bar
        setProgress(Math.round((100 * data.loaded) / data.total))
      },
    }).then(function (response) {
      console.log(response.data.id);
      setFile(response.data);
      // setURL(response.data.id)
      // setName(response.data.filename)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
 }

 const dragOver = (e) => {
  //console.log(e);
  e.preventDefault();
  setDragging(true)
}

const dragEnter = (e) => {
  console.log(e);
  e.preventDefault();
  setDragging(true)
}

const dragLeave = (e) => {
  console.log(e);
  e.preventDefault();
  setDragging(false)
}

const fileDrop = (e) => {
  e.preventDefault();
  const files = e.dataTransfer.files;
  console.log(files);
  setSelectedFile(files[0])
  setDragging(false)
}

//   return (
//     <Container>
//       <Row>
//         <Col lg={{ span: 4, offset: 3 }}>
//           <form
//             method="post"
//             encType="multipart/form-data"
//             onSubmit={submitHandler}
//           >
//             <input variant="info" type="submit"/>
//             {progress && <ProgressBar now={progress} label={`${progress}%`} />}
//           </form>
//           {url && <><a href={url}>{name}</a>
//             <button 
//   onClick={() =>  {copyToClipboard(url)} }>
//  Copy
// </button>}
//           <QRCode value={url} /></>}
//         </Col>
//       </Row>
//     </Container>
//   )
// }

// function Upload(){
  const share =() =>{
    if (navigator.canShare) {
        navigator.share({
          url : file.url,
          title: 'My Shared Files',
          text: 'Please download these files',
        })
        .catch((error) => console.log('Sharing failed', error));
      } else {
        let a  = document.createElement('a');
        a.setAttribute("href","whatsapp://send?text=Hii there, I am sharing some files with you. Download them using the code:  \n"+this.state.URL+"\n    at  http://192.168.0.104:3000");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
}
const copy = () =>{
    navigator.clipboard.writeText(file.url);
    console.table("Хуулагдлаа");
    let alert = document.getElementById("alertResult")
    alert.style.display = "block"
    alert.innerHTML="Хуулагдлаа"
    setTimeout(function(){ 
        alert.style.display="none"; 
    }, 1000);
}

  if (file) {
    return(
      <div className="Result">
          <img alt="scannable qr code" title="scannable qr code" src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${file.url}`} width="150px" height="150px" style={{marginBottom: "30px"}}/>
          <div className="textbox">
              <input type="text" readOnly={true} id="copy" value={file.id} />
              <button onClick={share} className="share" style={{outline:"none"}}> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAApgAAAKYB3X3/OAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAFXSURBVEiJtdU9S1xREAbgZ3SbKKQKFgkmpWgVEIuAqSIp9BekSZnOQtA2vQh2wVZ/gF0kmDaEgKWNdRDBJKjNZiMKe1LcvWaz33u9OzDNnPe+79z5OCdSSkZpY0U/jIh3AwFTSoUcNbzpi7uHwDVu8HqUAglVLIxSIOEXZjrhCje5xR7hc0Q8aT2oDMoQEc8wj6lGaLwF8hSHEfEypXR1F+1Rgod4j0/46V85+vlXPOjZAyzh+xCkrf4RlTYBTOID6vcgz30X0Uw+hi8lEDf7VvMUrWFR2dbIfhZ/Ss5+D0E2bkclkx/Im4znJZN/w0Te24psefrZJY5x1vAf2NS+qCdYSSnVmoM7XTI5l43sq/x3e9xFCaeY7oBrq39VtsET3ba8g8AF5rrg/gPu4/GQt+lvvOiBuyPfRgx5Xd9iuQ9OHRsF3oMa3g6As17wwVkdBBe5yqjsL4SrGniZcTgUAAAAAElFTkSuQmCC" alt="share icon" style={{backgroundColor:"white"}}/> </button>
          </div>
          <p style={{width:"80%",textAlign:"center",marginTop:"20px"}}>Линк:  <a href={file.url}>{file.url}</a></p>
          <button onClick={copy} className="CopyButton" style={{outline:"none"}}>Хуулах</button>
          <img alt='file transfer sucessful' src="https://swift-share.web.app/static/media/file-transfer-success.a7be3562.jpg" width={"400px"}/>
          <div color="success" id="alertResult">
          </div>
      </div>
  );     
  }

  return <div className="send">
                      
                    <div className="imgPanel">
                        <img src={require("./static/share-across.jpg")} width={"650px"} alt="sharing file" className="sendImage"/>
                    </div>
                    <div className="filePicker" onDragOver={dragOver}
    onDragEnter={dragEnter}
    onDragLeave={dragLeave}
    onDrop={fileDrop}
    style={ dragging ? {border: 'dashed 2px #0658c2'} : {}}
    >
                        <div className="filePicker-content">
                            <div onClick={handleClick}>
                            <img src="data:image/png;base64,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" width="100px" alt="Symbol of addition"/>
                            <h5>Файл сонгох</h5>
                            </div>
                            

                              <input type="file"
                                name="file"
                                ref={fileInput} 
                                id="upload-photo"
                                // onChange={e => {
                                //   setSelectedFiles(e.target.files)
                                // }}
                                onChange={(e) => handleFileChange(e)}
                              />
                            
                            {selectedFile && <><div className='filedisplay'> 
                                <h5>Файл</h5>
                                <p style={{borderBottom:'1px solid grey',marginBottom:'0'}}>{selectedFile.name}</p>
                                <p style={{fontSize:'12px'}}>{bytesToSize(selectedFile.size)}</p>
                                {progress && <ProgressBar id="statusIndicatorSend" now={progress} label={`${progress}%`} />}
                            </div><button id="upload" onClick={submitHandler}>Хуулах</button></>}
                        </div>
                    </div>
                    <div color="danger" id="alert">
                    </div>
                    
                </div>
}

export default Home
